import { NgModule } from '@angular/core';

import { CollapseAnimationDirective } from './animation.directive';

@NgModule({
  exports: [CollapseAnimationDirective],
  declarations: [CollapseAnimationDirective]
})
export class AnimationModule {}
